<template>
  <div class="liveCardWrap">
    <div
      class="live_on_header"
      :style="{
        background: `url(${teacherInfo.image}) center center / 50% no-repeat`,
      }"
    >
      <div class="frosted-glass"></div>
      <div class="lottie">
        <lottie :options="defaultOptions" v-on:animCreated="handleAnimation" />
      </div>
      <div class="live_on_img">
        <img :src="teacherInfo.image" alt="avatar" />
        <div class="live_on">
          <i></i>
        </div>
      </div>
      <div class="live_on_text">
        <h2>{{ liveCardInfo.room_name }}</h2>
        <!--5.9万 ·-->
        <p>{{ liveCardInfo.duration }}</p>
      </div>
      <div class="join_btn" @click="open_live">
        点击进入
      </div>
    </div>
  </div>
</template>
<script>
import lottie from "vue-lottie";
import Anim from "@/assets/ks.json";
export default {
  name: "",
  data() {
    return {};
  },
  props: {
    liveCardInfo: {
      // 直播卡片信息
      type: Object,
      default: () => {
        return {};
      },
    },
    teacherInfo: {
        type: Object,
        default: ()=>{
            return {}
        }
    },
  },
  components: {
    lottie: lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: Anim, loop: true, autoplay: true },
      defaultAnim: "",
      timer: null,
    };
  },
  created() {
  },
  methods: {
    handleAnimation: function (anim) {
      this.defaultAnim = anim;
    },
    open_live() {
      this.openNative('video_live_page', {
        id: this.liveCardInfo.room_id
      })
    },
    // 跳转APP页面
    openNative(type, query = {}) {
        let params = {
            kind: type, // 类型
        };

        params = {
          ...params,
          ...query
        }

        switch (type) {
            case "video_live_page": // 视频直播间
                break;
        }

        this.$srH5CallNativeMethodApp('call_Native', params)
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.liveCardWrap {
  background: #fff;
  margin-top: 12px;
  overflow: hidden;

  .live_on_header {
    display: flex;
    position: relative;
    margin: 0 18px;
    height: 93.5px;
    box-shadow: 0 1px 5px 0 rgba(217, 217, 217, 0.5);
    border-radius: 10px;
    border: 0.5px solid #CCC;

    .live_on_img {
      flex-shrink: 0;
      z-index: 2;
      position: relative;
      margin: 10.5px 14px 0 14px;
      width: 65.5px;
      height: 65.5px;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 3px solid #fa4547;
      }
      .live_on {
        position: absolute;
        width: 55px;
        height: 17px;
        background: url(https://cdn.stock-ring.com/static/wap/img/live_on.png) no-repeat;
        background-size: contain;
        border-radius: 16px;
        top: 55px;
        left: 50%;
        transform: translateX(-50%);
        
        i {
          width: 10px;
          height: 8px;
          background: url(https://cdn.stock-ring.com/static/wap/img/live.gif) no-repeat;
          position: absolute;
          left: 4.5px;
          top: 3.5px;
          background-size: 100%;
        }
      }
    }
    .live_on_text {
      z-index: 2;
      position: relative;
      flex: 1;
      min-width: 0;
      h2 {
        margin: 20px 0 20.5px;
        font-size: 15px;
        font-weight: 500;
        color: #fefffe;
        line-height: 18px;
        max-width: 90%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #fefffe;
        line-height: 16px;
        //热度先不做
      }
    }
    .frosted-glass {
      border-radius: 40px;
      position: absolute;
      background: inherit;
      -moz-filter: blur(23px);
      -ms-filter: blur(23px);
      -o-filter: blur(23px);
      filter: blur(23px);
      filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=4, MakeShadow=false);
      width: 100%;
      height: 100%;
      backdrop-filter: blur(23px);
    }
    .join_btn {
      z-index: 2;
      width: 70.5px;
      height: 27.5px;
      background: #ff3030;
      border-radius: 13.75px;
      margin-top: 51px;
      font-size: 12px;
      font-weight: 400;
      color: #fefffe;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 19.5px;
      bottom: 15px;
    }
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      content: "";
      background-color: #2b2b2b;
      opacity: 0.18;
      z-index: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      z-index: 1;
    }
  }

  .lottie {
    width: 50%;
    height: 190%;
    transform: translate3d(0, 0, 0);
    text-align: center;
    opacity: 1;
    position: absolute;
    top: -45%;
    left: -10%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>